<template>
  <v-container>
    <v-card max-width="800" class="mx-auto mb-10" light>
        <v-btn small @click="cambiarLang" color="amber" class="rounded-0 mx-9 mt-5">{{current_lang?'switch to ENglish':'cambiar a ESpañol'}} <v-icon x-small class="ml-3">fa-sync-alt</v-icon> </v-btn>
      <v-card-title class="mt-2 ml-5">
        {{ lang.title }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="font-weight-normal px-10">
        <template v-for="(parrafo, i) in lang.parrafos">
          <div v-if="parrafo.type === 'title'" :key="i">
            <div class="font-weight-bold">{{ parrafo.title }}</div>
            <p>{{ parrafo.text }}</p>
          </div>
          <div v-else :key="i">
            <p>
              <span class="font-weight-bold">{{ parrafo.title }}</span>
              {{ parrafo.text }}
            </p>
          </div>
        </template>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import lang from "@/lang/privacidadApp";

export default {
  data: () => ({

    current_lang: false,
    lang: lang.en
  }),
  methods: {
    cambiarLang(){
      this.current_lang = !this.current_lang
      if(this.current_lang){
        this.lang = lang.es
      }else{
        this.lang = lang.en
      }
    }
  }
};
</script>